import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description TimerSpeed icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { TimerSpeed } from '@sravni/design-system-icons'
 *
 * <TimerSpeed />
 * ```
 */
var TimerSpeed = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "TimerSpeed", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.333 1.667h3.333M7.5 8.333l2.5 2.5M16.667 4.167l-1.95 1.95M15.833 3.333 17.5 5M2.5 12.5h4.167M6.667 15h-2.5M6.666 17.5h-.833M3.557 9.166c.74-2.873 3.338-5 6.443-5A6.667 6.667 0 0 1 10 17.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { TimerSpeed };
//# sourceMappingURL=TimerSpeed.js.map
